"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  icon: 'w-auto h-[1em]'
};
var _default = exports["default"] = styles;
module.exports = exports.default;